<template>
	<span>
		<button class="btn btn-xs mx-1" title="pin beállítás" :class="{'btn-warning':user.pin_set,'btn-danger': !user.pin_set}" @click="openModal"><i class="fa fa-key"></i></button>
		<b-modal :id="'setPinModal'+user.id" cancel-variant="default" @ok="checkSignature()" ok-title="Beállítás" cancel-title="Mégse">
			<template slot="modal-header">
				<h4 class="modal-title">{{this.user.name}} - Pin kód beállítás</h4>
				<a class="btn-close" @click="closeModal"></a>
			</template>
			<form @submit.prevent="checkSignature()">
				
				<div class="form-group">
					<label class="form-label">Pin:</label>					
					<input class="form-control" :class="{'is-invalid' : errors.pin}" type="text" maxlength="6" inputmode="numeric" v-model="pin" required  data-type="password-field" @focus="setPw">
					<div v-if="errors.pin" class="invalid-feedback d-block">{{errors.pin[0]}}</div>
				</div>
			</form>
		</b-modal>
	</span>
</template>

<script>
import User from "../apis/User";
export default {
	props:{ user: Object},
	data() {
		return {
			pin:null,
			errors: [],
			back_url: false
		}
	},
	mounted(){
		this.back_url = process.env.VUE_APP_BACK_URL;
	},
	methods:{
		setPw(){
			document.querySelector('[data-type="password-field"]').setAttribute('type','password');
			
		},
		closeModal(){
			this.$bvModal.hide('setPinModal'+this.user.id);
			this.pin = null;
			this.errors = [];
			this.$emit('pinset',true);
		},
		openModal(){
			this.$bvModal.show('setPinModal'+this.user.id);
			window.open(this.back_url+'/document/pdf/log/'+this.user.id,'_blank').focus();
		},
		checkSignature(){
			this.$swal({
				title: 'Aláírta a jegyzőkönyvet?',
				text: 'A jegyzőkönyv aláírása nélkül nem állíthat be Pint',
				type: 'warning',
				icon: 'question',
				iconColor: 'orange',
				showCancelButton: true,
				buttonsStyling: false,
				confirmButtonText: 'Igen',
				cancelButtonText: 'Nem',
				confirmButtonClass: 'btn btn-lg me-15px btn-success',
				cancelButtonClass: 'btn btn-lg btn-danger',
			}).then(response => {
				if(response.isConfirmed === true){
					User.setPin({user_id: this.user.id, pin:this.pin})
					.then(() => {
						this.closeModal();
					}).catch(error => {
						if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
						this.$bvModal.show('setPinModal'+this.user.id);
					})
				}else{
					this.$bvModal.show('setPinModal'+this.user.id)
				}
			});
		}
	}
}
</script>